<header class="page-header">
	<ng-container *ngIf="hasBackButton; else defautHeaderTemplate">
		<div class="page-header-back-button">
			<button type="button" class="btn btn-transparent" (click)="backNavigation()">
				<i class="far" ngClass="fa-chevron-left"></i>
			</button>
			<h1 id="page-header-title" class="page-header-title" [style]="hasSpecialStyle ? 'color : red' : ''"><span>{{ pageTitle }}</span></h1>
			<p id="page-header-sub-title" class="page-header-sub-title" [style]="hasSubSpecialStyle ? 'color : red' : ''"><span>{{ pageSubTitle }}</span></p>
			<h1 id="page-header-title-affaire-name"
				class="page-header-title-affaire-name"
				[matTooltip]='tooltip'
				>
				<span>{{ pageTitleAffaireName }}</span>
			</h1>
		</div>
	</ng-container>

	<div class="page-header-actions">
		<ng-content> </ng-content>
	</div>
</header>

<ng-template #defautHeaderTemplate>
	<h1 id="page-header-title" class="page-header-title">{{ pageTitle }}</h1>
	<p id="page-header-sub-title" class="page-header-sub-title"style="margin-top: 44px; left: 45px;" >
		{{ pageSubTitle }}
	</p>
</ng-template>
